export const ROLES_TYPES = {
  ORGANIZATION: 'organization',
  SERVICE: 'service',
  GLOBAL: 'global',
  SERVICE_DISPLAY: 'serviceDisplay',
  OWNER: 'owner',
  SUPERADMIN: 'superadmin',
}
